import styled from "@emotion/styled";
import { Banner } from "@xometry/xometry_loft";

export const PrivacyBannerBase = styled(Banner)<{ showBanner: boolean }>`
  display: ${(props) => (props.showBanner ? "flex" : "none")} !important;
`;
